<template>
    <div v-loading="$parentInfo.studentCourseRecord.dialog_CancelCourse.loading">
        <div class="card-body">
            <el-form label-position=right label-width="80px">
                <el-row :span="20">
                    <el-col :span="10">
                        <el-form-item label="可退课时">
                            <el-input v-model="$parentInfo.studentCourseRecord.dialog_CancelCourse.retire_period"
                                      disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="单价">
                            <el-input
                                    v-model="$parentInfo.studentCourseRecord.dialog_CancelCourse.studentPeriod.unit_period_price"
                                    disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="20">
                    <el-col :span="10">
                        <el-form-item label="取消原因">
                            <el-select v-model="$parentInfo.studentCourseRecord.dialog_CancelCourse.reason_id"
                                       placeholder="请选择原因">
                                <el-option
                                        v-for="item in options"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="具体原因">
                            <el-input v-model="$parentInfo.studentCourseRecord.dialog_CancelCourse.reason"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="text-right">
            <!--<el-button type="primary" size="small" @click="handleUpdateStudentPeriod('cancel_period')"-->
                       <!--:loading="$parentInfo.studentCourseRecord.dialog_CancelCourse.button_loading">退课时-->
            <!--</el-button>-->
            <!--<el-button type="primary" size="small" @click="handleUpdateStudentPeriod('cancel_coupon')"-->
                       <!--:loading="$parentInfo.studentCourseRecord.dialog_CancelCourse.button_loading"-->
                       <!--v-if="powers.includes(129)">退优惠券-->
            <!--</el-button>-->
            <el-button type="primary" size="small" @click="handleUpdateStudentPeriod('cancel_money')"
                       :loading="$parentInfo.studentCourseRecord.dialog_CancelCourse.button_loading">退费
            </el-button>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Dialog_CancelCourse",
        data() {
            return {
                options: [
                    {'id': 1, 'name': '老师授课原因'},
                    {'id': 2, 'name': '非老师原因'},
                ],
            };
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentCourseRecord.dialog_CancelCourse.loading = true;
            this.$parentInfo.studentCourseRecord.dialog_CancelCourse.reason = '';
            this.$parentInfo.studentCourseRecord.dialog_CancelCourse.reason_id = '';
            this.handleShowStudentPeriod();
        },
        methods: {
            handleShowStudentPeriod() {
                this.$wApi.send(this.$parentInfo.path, 'showStudentPeriod', {
                    'period_id': this.$store.state.modal.data.studentPeriod_id,
                });
            },
            handleUpdateStudentPeriod(type) {
                if (this.$parentInfo.studentCourseRecord.dialog_CancelCourse.retire_period === 0) {
                    this.$message({
                        showClose: true,
                        message: '剩余课时为0，无法退费、课时或者优惠券',
                        type: 'warning'
                    });
                } else {
                    this.$parentInfo.studentCourseRecord.dialog_CancelCourse.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'updateStudentPeriod', {
                        'period_id': this.$store.state.modal.data.studentPeriod_id,
                        'student_id': this.$parentInfo.student_id,
                        'cancel_reason': this.$parentInfo.studentCourseRecord.dialog_CancelCourse.reason,
                        'cancel_reason_id': this.$parentInfo.studentCourseRecord.dialog_CancelCourse.reason_id,
                        'type': type,
                        'status': 'cancel',
                    });
                }
            },
        }
    };
</script>
